import React, { useState } from "react";
import { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import FetchData from "../../providers/dataProvider"
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import ValidateField from '../../hooks/useValid';
import { ValidateName } from '../../constants/ValidateNameConstants';
import { PriceCheck, CheckNull } from "../../utils/Validate"

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #c8d8e8",
    backgroundColor: "#ffffff",
    fontSize: "13px",
    minHeight: "34px",
    height: "34px",
    borderRadius: "7px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};

export default function UpdateStatus({
  openStatus,
  handleStatusClose,
  quotationStatus,
  handleQuotationStatusUpdate,
}) {
  const [quoteStatus, setQuoteStatus] = useState([]);
  const [quoteStatusFinal, setQuoteStatusFinal] = useState([]);
  const [quoteStatusValue, setQuoteStatusValue] = useState(null);
  const [lostReasonValue, setLostReasonValue] = useState(null);
  const [formValues, setFormValues] = useState({})
  const [isSubmit, setIsSubmit] = useState(false)
  const [formError, setFormError] = useState({})

  const { data: lostReason } = FetchData("lostReason");

  const formatStatusOption = (data) => ({
    ...data,
    label: data?.label || data?.statusDesc,
    value: data?.value ?? data?.id,
  });

  const formatQuotationStatus = (list) => {
    var te = list?.map((data, index) => ({
      ...data,
      label: data?.label || data?.statusDesc,
      value: data?.value ?? data?.id,
    }));
    return te;
  };

  useEffect(() => {
    const selectedStatus = openStatus?.selectedStatus
      ? formatStatusOption(openStatus?.selectedStatus)
      : null;

    setFormError({});
    setQuoteStatusValue(selectedStatus);
    setLostReasonValue(null);
    setFormValues({});
    setIsSubmit(false);
  }, [openStatus]);

  useEffect(() => {
    if (quotationStatus) {
      const lists = quotationStatus?.filter(
        (el) =>
          el?.statusDesc != "Cancelled" && el?.statusDesc != "Order Received"
      );
      const list = formatQuotationStatus(lists);
      setQuoteStatus(list);
      setQuoteStatusFinal(list);
    }
  }, [quotationStatus]);

  useEffect(() => {
    const finalList = quoteStatusFinal?.filter(
      (itm) => itm?.id > openStatus?.item?.quoteStatusId
    );
    setQuoteStatus(finalList);
  }, [openStatus?.item, quoteStatusFinal]);

  const handleQuoteStatusChange = (selectedOption) => {
    setQuoteStatusValue(selectedOption);
  };

  const handleLostReasonChange = (selectedOption) => {
    setLostReasonValue(selectedOption)

    // re-run the validation check on the changed field value
    const errors = validationStatus(formValues, selectedOption);
    // update the formErrors state
    setFormError({
      ...formError,
      lostReason: errors["lostReason"]
    });
  }

  const HandleFormChange = (e) => {
    const { name, value } = e.target
    setFormValues({ ...formValues, [name]: value })

    // re-run the validation check on the changed field value
    const errors = validationStatus({
      ...formValues,
      [name]: value
    }, lostReasonValue);
    // update the formErrors state
    setFormError({
      ...formError,
      [name]: errors[name]
    });
  }

  const validationStatus = (values, lostReason) => {
    const errors = {};

    errors.quoteStatus = ValidateField(
      quoteStatusValue?.label,
      ValidateName?.QUOTE_STATUS,
      ValidateName?.QUOTE_STATUS,
      [ValidateName?.REQUIRED],
    );

    if (quoteStatusValue?.label === "Lost") {
      errors.lostReason = ValidateField(
        lostReason?.label,
        ValidateName?.QUOTE_LOSTREASON,
        ValidateName?.QUOTE_LOSTREASON,
        [ValidateName?.REQUIRED],
      );

      errors.lostTo = ValidateField(
        values.lostTo,
        ValidateName?.QUOTE_LOSTTO,
        ValidateName?.QUOTE_LOSTTO,
        [ValidateName?.REQUIRED],
      );

      errors.lostDetails = ValidateField(
        values.lostDetails,
        ValidateName?.QUOTE_LOSTDETAILS,
        ValidateName?.QUOTE_LOSTDETAILS,
        [ValidateName?.REQUIRED],
      );

      errors.lostPrice = ValidateField(
        values.lostPrice,
        ValidateName?.QUOTE_LOSTPRICE,
        ValidateName?.QUOTE_LOSTPRICE,
        [ValidateName?.REQUIRED,ValidateName?.ISPOSITIVENUMBER],
      );
    }

    let error = {}
    Object.keys(errors).map((key, index) => {
      if (errors[key] !== undefined) {
        error[key] = errors[key]
      }
    })

    return error
  }

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      const newStatus = {
        quotationId: openStatus?.item?.id,
        newStatusId: quoteStatusValue?.value,
        lostReasonId: lostReasonValue?.value || 0,
        lostTo: formValues?.lostTo || "",
        lostDetails: formValues?.lostDetails || "",
        lostPrice: formValues?.lostPrice || 0
      }
      handleQuotationStatusUpdate(newStatus);
    }
    else { setIsSubmit(false) }
  }, [formError])

  const handleStatusUpdate = (event) => {
    event.preventDefault();
    setFormError(validationStatus(formValues, lostReasonValue));
    setIsSubmit(true);
  };

  const handleClose = () => {
    setQuoteStatusValue(null);
    setLostReasonValue(null);
    setFormValues({})
    handleStatusClose();
    setFormError({});
    setIsSubmit(false)
  };

  return (
    <Modal
      show={openStatus?.open}
      centered
      size="sm"
      onHide={handleClose}
      aria-labelledby="quotation-status-title"
      backdropClassName="quotation-status-backdrop"
      className="updateStatusModal quotation-status-modal"
      dialogClassName="quotation-status-dialog"
    >
      <Modal.Header className="quotation-status-header">
        <div className="quotation-status-title">
          <span className="quotation-status-title-icon">
            <i className="fas fa-flag"></i>
          </span>
          <div>
            <h5 className="modal-title" id="quotation-status-title">Update Status</h5>
            <p>{openStatus?.item?.quoteReference || openStatus?.item?.projectRef || "Quotation"}</p>
          </div>
        </div>
        <button
          type="button"
          className="quotation-status-close"
          aria-label="Close status update"
          onClick={handleClose}
        >
          <i className="fas fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="quotation-status-body">
        <div className="quotation-status-summary">
          <span>Current</span>
          <strong>{openStatus?.item?.quoteStatus || openStatus?.item?.status || openStatus?.item?.statusDesc || "Status update"}</strong>
        </div>
        <div className="quotation-status-field">
          <label htmlFor="quotation-status-select">
            New Status <span className="mandatory">*</span>
          </label>
          <DropDownComponent
            inputId="quotation-status-select"
            placeHolder={PlaceHolder.SELECT_STATUS}
            pageName="updateStatus"
            dpDownName="quotestatus"
            stateData={quoteStatus}
            controlName="quotestatus"
            handleChange={handleQuoteStatusChange}
            value={quoteStatusValue}
            valueId={quoteStatusValue?.value || ""}
            setState={setQuoteStatusValue}
            customStyles={style}
          />
          {formError?.quoteStatus && (
            <p className="form-error">{formError?.quoteStatus}</p>
          )}
        </div>
        {quoteStatusValue?.label === "Lost" ? (
          <div className="quotation-lost-panel">
            <div className="quotation-lost-panel-header">
              <span>Lost Details</span>
            </div>
            <div className="quotation-status-field">
              <label htmlFor="quotation-lost-reason">
                Reason <span className="mandatory">*</span>
              </label>
              <DropDownComponent
                inputId="quotation-lost-reason"
                placeHolder={PlaceHolder.SELECT_LOST_REASON}
                pageName="updateStatus"
                dpDownName="lostreason"
                stateData={lostReason}
                controlName="lostReason"
                handleChange={handleLostReasonChange}
                value={lostReasonValue}
                valueId={lostReasonValue?.value || ""}
                setState={setLostReasonValue}
                customStyles={style}
              />
              {formError?.lostReason && (
                <p className="form-error">{formError?.lostReason}</p>
              )}
            </div>
            <div className="quotation-lost-grid">
              <div className="quotation-status-field">
                <label htmlFor="quotation-lost-to">
                  Lost To <span className="mandatory">*</span>
                </label>
                <input
                  id="quotation-lost-to"
                  type="text"
                  className="form-control"
                  placeholder={PlaceHolder.LOST_TO}
                  name="lostTo"
                  onChange={HandleFormChange}
                  value={formValues?.lostTo || ""}
                ></input>
                {formError?.lostTo && (
                  <p className="form-error">{formError?.lostTo}</p>
                )}
              </div>
              <div className="quotation-status-field">
                <label htmlFor="quotation-lost-price">
                  Lost Price <span className="mandatory">*</span>
                </label>
                <input
                  id="quotation-lost-price"
                  type="number"
                  className="form-control"
                  step=".01"
                  min="0"
                  placeholder={PlaceHolder.LOST_PRICE}
                  name="lostPrice"
                  onChange={HandleFormChange}
                  onKeyPress={(e) => { return PriceCheck(e.target.value) }}
                  value={formValues?.lostPrice || ""}
                  onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                ></input>
                {formError?.lostPrice && (
                  <p className="form-error">{formError?.lostPrice}</p>
                )}
              </div>
            </div>
            <div className="quotation-status-field">
              <label htmlFor="quotation-lost-details">
                Lost Details <span className="mandatory">*</span>
              </label>
              <textarea
                id="quotation-lost-details"
                className="form-control"
                placeholder={PlaceHolder.LOST_DETAILS}
                name="lostDetails"
                onChange={HandleFormChange}
                value={formValues?.lostDetails || ""}
              />
              {formError?.lostDetails && (
                <p className="form-error">{formError?.lostDetails}</p>
              )}
            </div>
          </div>
        ) : ""}
      </Modal.Body>
      <Modal.Footer className="quotation-status-footer">
        <button
          type="button"
          className="btn cancel-btn"
          onClick={handleClose}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn save-btn"
          onClick={handleStatusUpdate}
        >
          Update
        </button>
      </Modal.Footer>
    </Modal>
  );
}
